import type { ISystem, ISystemGroup } from '../types';
import { isGroup } from './isGroup';
import { isSystem } from './isSystem';

export const getSystemsFromChildGroups = (gs: ISystemGroup | ISystem): ISystem[] => {
  if (!isGroup(gs)) return [];

  return gs.childGroups?.filter(isSystem);
};
